// W3 Clients: the module contract (features/README.md). Exports exactly routes, navigation and permissions.
import type { FeatureModule } from '@care-platform/shell';
import { Users } from 'lucide-react';

export const permissions: FeatureModule['permissions'] = ['clients.read'];

export const routes: FeatureModule['routes'] = [
  { id: 'clients.list', path: '', load: () => import('./list/clients-list-page') },
  { id: 'clients.detail', path: ':clientId', load: () => import('./detail/client-detail-page') },
];

export const navigation: FeatureModule['navigation'] = [
  {
    id: 'clients',
    routeId: 'clients.list',
    label: (copy) => copy.nav.clients,
    icon: Users,
    pillar: 'clinical',
    permission: 'clients.read',
    order: 20,
  },
];
